export default {
    title: 'Exclusão de Conta',
    warning: 'Atenção: após a exclusão não é mais possível reativar a sua conta!',
    disclaimer: 'Você terá que aguardar 30 dias para criar uma nova conta com o mesmo e-mail caso deseje voltar a usar o Astrolink.<br />Além disso, você perderá definitivamente todos os seus dados salvos de perfil, Mapas extras, Sinastrias, Tarot, Diário e lista de amigos.<br />Sua solicitação de exclusão pode levar alguns dias para ser processada.',
    goodbyeImgAlt: 'Duas pessoas se despedindo',
    subscriptionCheck: 'Verificando status da conta',

    passwordConfirm: {
        error: 'Senha incorreta',
        placeholder: 'Informe sua senha',
        text: '{name}, caso deseje, você pode excluir a sua conta, mas lembre-se de que esta é uma ação irreversível.'
    },

    textfield: {
        placeholder: 'Gostaria de deixar sua opinião? (opcional)'
    },

    form: {
        title: 'Nos ajude a melhorar',
        subtitle: 'Por que você deseja excluir a sua conta do Astrolink? (obrigatório)',
        reason0: 'Acredito já ter visto todo o conteúdo',
        reason1: 'Bugs/mal funcionamento do site',
        reason2: 'Preocupação com o uso dos meus dados',
        reason3: 'Não me interesso mais por Astrologia',
        reason4: 'Uso outra plataforma de Astrologia',
    },

    confirmation: {
        title: 'Código de Confirmação',
        text: 'Para a sua segurança, enviamos um código de quatro dígitos via e-mail. Insira-o no campo abaixo para confirmar a exclusão de conta.',
        button: 'Confirmar Exclusão',
        tryAgain: 'Não recebeu o e-mail? Tente ',
        tryAgainButton: 'enviar novamente',
        support: 'Caso você não tenha mais acesso e-mail de cadastro, entre em contato com o nosso <a href="{url}">suporte</a>',
    },

    deleted: {
        title: 'Sua conta foi excluída com sucesso!',
        redirect: 'Você será redirecionado para a página inicial em alguns segundos'
    },

    error: {
        incorrectCode: 'Código incorreto',
        default: 'Erro ao buscar informações de assinatura',
        confirmationCode: 'Erro ao enviar o email, tente novamente',
        cancel: '<strong>{userName}</strong>, você é um Usuário Assinante do Astrolink. Para excluir sua conta é necessário cancelar antes a sua assinatura. <a href="{url}">Clique aqui</a> para preencher o formulário de cancelamento.',
        apple: '<strong>{userName}</strong>, você é um Usuário Assinante do Astrolink. Para excluir sua conta é necessário cancelar antes a sua assinatura. <a href="https://support.apple.com/pt-br/HT202039" target="_blank" rel="noopener noreferrer">Clique aqui</a> para acessar o painel de assinaturas na <strong>Apple</strong> e solicitar o cancelamento da mesma.',
        play: '<strong>{userName}</strong>, você é um Usuário Assinante do Astrolink. Para excluir sua conta é necessário cancelar antes a sua assinatura. <a href="https://play.google.com/store/account/subscriptions" target="_blank" rel="noopener noreferrer">Clique aqui</a> para acessar o painel de assinaturas na <strong>Google Play</strong> e solicitar o cancelamento da mesma.',
        consent: '<strong>Atenção!</strong><br /> Você é assinante Premium do Astrolink, e ainda possui dias restantes para desfrutar de sua assinatura com todos os benefícios. Caso deseje prosseguir com a exclusão de sua conta, você concorda em abdicar dos dias restantes de assinatura sem direito a reembolso ou arrependimento. <br /><strong>Lembre-se:</strong> a exclusão de sua conta é definitiva e irreversível.'
    }
};